import { useState } from 'react';
import { Button } from '../ui/button';

const LANGS = [
  { code: 'ja', label: '日本語' },
  { code: 'pt', label: 'Português' },
  { code: 'en', label: 'English' },
];

export function LangTabs({ activeLang, onChange }) {
  return (
    <div className="flex gap-1 p-1 bg-secondary/50 rounded-lg w-fit" data-testid="lang-tabs">
      {LANGS.map(l => (
        <Button
          key={l.code}
          size="sm"
          variant={activeLang === l.code ? 'default' : 'ghost'}
          className="h-7 text-xs px-3"
          onClick={() => onChange(l.code)}
          data-testid={`lang-tab-${l.code}`}
        >
          {l.label}
        </Button>
      ))}
    </div>
  );
}

export function useLangForm(initialForm, langFields) {
  const [lang, setLang] = useState('ja');

  const getField = (form, field) => {
    if (lang === 'ja') return form[field] || '';
    return form[`${field}_${lang}`] || '';
  };

  const setField = (form, setForm, field, value) => {
    if (lang === 'ja') {
      setForm({ ...form, [field]: value });
    } else {
      setForm({ ...form, [`${field}_${lang}`]: value });
    }
  };

  return { lang, setLang, getField, setField };
}
